import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Business Cards - INGAZ Print";

function BusinessCards() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          {/* Product Details Section */}
          <section className="product-details-section">
            <div className="product-container">
              {/* Left: Product Image Gallery */}
              <ProductGallery alt="Business Cards" images={[asset('assets/business_card_main_hero_1769364457825.png'), asset('assets/business_card_stack_1769358189785.png'), asset('assets/business_card_fan_1769358204779.png'), asset('assets/business_card_detail_1769358219462.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h1>
                <p className="product-description" data-en="Professional business cards that make a lasting impression. High-quality paper and finishing options." data-ar="بطاقات عمل احترافية تترك انطباعًا دائمًا. ورق عالي الجودة وخيارات تشطيب متنوعة.">Professional
                  business cards that make a lasting impression. High-quality paper and finishing options.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Essential for networking and brand identity" data-ar="ضروري للتواصل وهوية العلامة التجارية">
                      Essential for networking and brand identity</li>
                    <li data-en="Premium paper stocks for a professional feel" data-ar="ورق فاخر لإحساس احترافي">
                      Premium paper stocks for a professional feel</li>
                    <li data-en="Customizable finishes like Spot UV and Foil" data-ar="تشطيبات قابلة للتخصيص مثل Spot UV و Foil">
                      Customizable finishes like Spot UV and Foil</li>
                    <li data-en="Double-sided printing available for more info" data-ar="طباعة على الوجهين متاحة لمزيد من المعلومات">
                      Double-sided printing available for more info</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/bag.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Networking" data-ar="التواصل">Networking</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Client Meetings" data-ar="اجتماعات العملاء">Client Meetings</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Trade Shows" data-ar="المعارض التجارية">Trade Shows</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Brand Intro" data-ar="مقدمة العلامة التجارية">Brand Intro</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          {/* Configuration Section */}
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Business Cards" data-ar="قم بتكوين بطاقات العمل الخاصة بك">Configure Your Business Cards</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                  <p className="config-hint" data-en="Example: 1 box = 100 cards and 10 boxes = 1,000 cards in total" data-ar="مثال: 1 علبة = 100 بطاقة و 10 علب = 1,000 بطاقة إجمالاً">Example: 1 box = 100 cards and 10 boxes = 1,000 cards in total</p>
                </div>
                {/* Number of different names */}
                <div className="config-group">
                  <label data-en="Number of different names on business cards" data-ar="عدد الأسماء المختلفة على بطاقات العمل">Number of different names on business cards</label>
                  <p className="config-hint" data-en="Please select one option:" data-ar="يرجى تحديد خيار واحد:">Please select one option:</p>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="nameOption" defaultValue="one" defaultChecked />
                      <span data-en="One name only (same details on all boxes)" data-ar="اسم واحد فقط (نفس التفاصيل على جميع العلب)">One name only (same details on all boxes)</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="nameOption" defaultValue="multiple" />
                      <span data-en="Multiple names" data-ar="أسماء متعددة">Multiple names, if multiple names, please specify:</span>
                    </label>
                  </div>
                  <div className="config-subgroup" style={{marginTop: '12px'}}>
                    <div style={{display: 'flex', gap: '16px', flexWrap: 'wrap'}}>
                      <div style={{flex: 1, minWidth: '200px'}}>
                        <label htmlFor="numNames" data-en="Number of different names" data-ar="عدد الأسماء المختلفة">Number of different names</label>
                        <input type="number" id="numNames" placeholder="Enter number" min={1} data-placeholder-en="Enter number" data-placeholder-ar="أدخل العدد" />
                      </div>
                      <div style={{flex: 1, minWidth: '200px'}}>
                        <label htmlFor="boxesPerName" data-en="Number of boxes per name" data-ar="عدد العلب لكل اسم">Number of boxes per name</label>
                        <input type="number" id="boxesPerName" placeholder="Enter number" min={1} data-placeholder-en="Enter number" data-placeholder-ar="أدخل العدد" />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="50x90" data-dims="50x90"><span>50 × 90</span><br /><span>mm</span></div>
                    <div className="size-option" data-size="50x95" data-dims="50x95"><span>50 × 95</span><br /><span>mm</span></div>
                    <div className="size-option" data-size="50x50" data-dims="50x50"><span>50 × 50</span><br /><span>mm</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Custom" data-ar="مخصص">Custom</span><br /><span data-en="L × W" data-ar="الطول × العرض">L × W</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="couche-350" data-en="Couche 350 gsm" data-ar="كوشيه 350 جم">Couche 350 gsm</option>
                      <option value="fabriano-230" data-en="Fabriano 230 gsm" data-ar="فابريانو 230 جم">Fabriano 230 gsm</option>
                      <option value="crystal-gold-230" data-en="Crystal Gold 230 gsm" data-ar="كريستال ذهبي 230 جم">Crystal Gold 230 gsm</option>
                      <option value="crystal-silver-230" data-en="Crystal Silver 230 gsm" data-ar="كريستال فضي 230 جم">Crystal Silver 230 gsm</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printing Sides */}
                <div className="config-group">
                  <label data-en="Printing Sides" data-ar="جوانب الطباعة">Printing Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="Single Side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Single Side</span>
                    </div>
                    <div className="side-option" data-sides="double" data-en="Double Sides" data-ar="جانبان">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Double Sides</span>
                    </div>
                  </div>
                </div>
                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="matt" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Matt Cellophane" data-ar="سيلوفان غير لامع">Matt Cellophane</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="gloss" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Gloss Cellophane" data-ar="سيلوفان لامع">Gloss Cellophane</span>
                    </label>
                  </div>
                  <p className="config-note" data-en="Note: Cellophane should be dimmed in the case of all other paper types than Couche" data-ar="ملاحظة: يجب أن يكون السيلوفان معتمًا في حالة جميع أنواع الورق الأخرى غير الكوشيه"><em>Note: Cellophane should be dimmed in the case of all other paper types than Couche</em></p>
                </div>
                {/* Corners */}
                <div className="config-group">
                  <label data-en="Corners" data-ar="الزوايا">Corners</label>
                  <div className="side-options">
                    <div className="side-option active" data-corners="square" data-en="Square" data-ar="مربعة">
                      <span>Square</span>
                    </div>
                    <div className="side-option" data-corners="rounded" data-en="Rounded" data-ar="مستديرة">
                      <span>Rounded</span>
                    </div>
                  </div>
                </div>
                {/* Special Finishing */}
                <div className="config-group">
                  <label data-en="Special Finishing (optional)" data-ar="التشطيب الخاص (اختياري)">Special Finishing (optional)</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="spot-uv" />
                      <span data-en="Spot UV" data-ar="سبوت يو في">Spot UV</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="embossing" />
                      <span data-en="Embossing" data-ar="النقش البارز">Embossing</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="finishing" defaultValue="foil" />
                      <span data-en="Foil Stamping [Silver/Gold/Others]" data-ar="ختم بالرقائق [فضي/ذهبي/أخرى]">Foil Stamping [Silver/Gold/Others]</span>
                    </label>
                  </div>
                  <textarea id="finishingNotes" placeholder="Describe the areas to have Spot UV, Embossing or Foil Stamping and whether on one side or two sides" rows={3} data-placeholder-en="Describe the areas to have Spot UV, Embossing or Foil Stamping and whether on one side or two sides" data-placeholder-ar="حدد المناطق التي تريد فيها سبوت يو في أو النقش البارز أو ختم الرقائق وما إذا كان على جانب واحد أو جانبين" defaultValue={""} />
                </div>
                {/* Upload Artwork */}
                <div className="config-group">
                  <label data-en="Upload Artwork" data-ar="رفع التصميم">Upload Artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
                {/* Additional Notes */}
                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">50 × 90 mm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Paper:" data-ar="الورق:">Paper:</span>
                    <span className="summary-value" id="summaryPaper">Couche 350 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Sides:" data-ar="جوانب الطباعة:">Sides:</span>
                    <span className="summary-value" id="summarySides">Single Side</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Lamination:" data-ar="التغليف:">Lamination:</span>
                    <span className="summary-value" id="summaryLamination">None</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Corners:" data-ar="الزوايا:">Corners:</span>
                    <span className="summary-value" id="summaryCorners">Square</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Finishing:" data-ar="التشطيب:">Finishing:</span>
                    <span className="summary-value" id="summaryFinishing">None</span>
                  </div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="1-2 business days" data-ar="1-2 أيام عمل">1-2 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus" />
                  </div>
                  <h3 data-en="Menus" data-ar="القوائم">Menus</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default BusinessCards;
